export function Calendar() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="currentcolor"
    >
      <path d="M5.71429 1.5C5.71429 0.671719 6.41652 0 7.28571 0C8.15491 0 8.85714 0.671719 8.85714 1.5V3H15.1429V1.5C15.1429 0.671719 15.8451 0 16.7143 0C17.5835 0 18.2857 0.671719 18.2857 1.5V3H20.6429C21.9442 3 23 4.00734 23 5.25V7.5H1V5.25C1 4.00734 2.05531 3 3.35714 3H5.71429V1.5ZM23 21.75C23 22.9922 21.9442 24 20.6429 24H3.35714C2.05531 24 1 22.9922 1 21.75V9H23V21.75Z" />
    </svg>
  );
}
